import { createWidget } from "@opendash/plugin-monitoring";
import React from "react";
import { ConfigInterface } from "./types";

export default createWidget<ConfigInterface>({
  type: "opendash-widget-hc-timeseries",
  meta: {},
  displayComponent: React.lazy(() => import("./component")),
  settingsComponent: React.lazy(() => import("./settings")),

  dataItems: {
    select: "dimension",
    min: 1,
    types: ["Number", "Boolean"],
  },

  dataFetching: {
    live: true,
    history: true,
  },

  dataExplorer: {
    title: "highcharts:explorer.timeseries.title",
    description: "highcharts:explorer.timeseries.description",
    icon: "fa:chart-line",
    config: {
      interaction_zoom_x: true,
      interaction_legend: true,
      interaction_tooltips: true,
    },
  },

  presets: [
    {
      label: "highcharts:explorer.historyMinMax.title",
      description: "highcharts:explorer.historyMinMax.description",
      tags: ["charttime"],
      imageLink: async () => (await import("./res_057")).default,
      layout: [6, 24] as [number, number],
      widget: {
        config: {
          interaction_minmax: false,
          interaction_minimap: false,
          interaction_tooltips: true,
          interaction_zoom_x: true,
          interaction_legend: true,
          _history: {
            historyType: "relative",
            value: 1,
            unit: "week",
          },
        },
      },
    },
    {
      label: "highcharts:explorer.live.title",
      description: "highcharts:explorer.live.description",
      tags: ["charttime"],
      imageLink: async () => (await import("./res_734")).default,
      layout: [6, 12] as [number, number],
      widget: {
        config: {
          interaction_zoom_x: true,
          interaction_tooltips: true,
          _history: {
            live: true,
          },
        },
      },
    },
  ],
});
